export const caseCategories = [
  { id: "all", name: "全部现场", icon: "ri-fire-line" },
  { id: "caught", name: "被抓现行", icon: "ri-eye-line" },
  { id: "exposed", name: "被拆穿瞬间", icon: "ri-alarm-warning-line" },
  { id: "slap", name: "打脸现场", icon: "ri-emotion-laugh-line" },
  { id: "death", name: "社死瞬间", icon: "ri-emotion-unhappy-line" },
  { id: "collection", name: "翻车合集", icon: "ri-stack-line" },
];

export const cases = [
  {
    id: "case-01",
    title: "他把「加班」说了整整三个月，直到定位显示在同一家酒店",
    category: "caught",
    categoryName: "被抓现行",
    summary:
      "连续三个月的深夜加班，外卖地址却永远指向城东。最后一晚，她只是随口问了句「你工位旁边那盆绿萝还在吗」，对面沉默了整整十一秒。",
    cover:
      "https://readdy.ai/api/search-image?query=Torn%20open%20envelope%20and%20scattered%20paper%20notes%20on%20a%20warm%20wooden%20table%20lit%20by%20a%20single%20harsh%20red%20desk%20lamp%2C%20abstract%20editorial%20still%20life%2C%20dramatic%20shadows%2C%20film%20grain%2C%20cinematic%20investigation%20mood%2C%20no%20people&width=800&height=600&seq=expose-case-01&orientation=landscape",
    date: "2026-09-08",
    views: "18.6万",
    likes: 5421,
    heat: 98,
    duration: "5分钟",
    tags: ["深夜加班", "定位打脸", "证据链"],
  },
  {
    id: "case-02",
    title: "群发晚安翻车：他把给别人的情话，错发到了家族群",
    category: "slap",
    categoryName: "打脸现场",
    summary:
      "凌晨一点十七分，一条堪称教科书级别的深夜情话出现在家族群里。三分钟后撤回，但姑妈、二舅和表妹已经截图留念。",
    cover:
      "https://readdy.ai/api/search-image?query=Cracked%20smartphone%20screen%20glowing%20with%20blurred%20message%20bubbles%20on%20a%20dark%20desk%2C%20abstract%20editorial%20close%20up%2C%20crimson%20reflections%2C%20deep%20shadows%2C%20film%20grain%2C%20dramatic%20documentary%20photography%2C%20no%20people&width=800&height=600&seq=expose-case-02&orientation=landscape",
    date: "2026-09-07",
    views: "24.1万",
    likes: 8032,
    heat: 96,
    duration: "3分钟",
    tags: ["错发消息", "家族群", "社死预警"],
  },
  {
    id: "case-03",
    title: "纪念日当天，他给两个人的备注都是「宝贝」",
    category: "exposed",
    categoryName: "被拆穿瞬间",
    summary:
      "餐厅订位短信发到她手机上，名字却不是她。她只是把屏幕转了个方向，对面的笑容一寸一寸凝固。",
    cover:
      "https://readdy.ai/api/search-image?query=Scattered%20polaroid%20photos%20and%20a%20red%20wax%20seal%20stamp%20on%20wrinkled%20paper%2C%20high%20contrast%20editorial%20still%20life%2C%20harsh%20side%20lighting%2C%20crimson%20accents%2C%20film%20grain%2C%20cinematic%20mood%2C%20no%20people&width=800&height=600&seq=expose-case-03&orientation=landscape",
    date: "2026-09-06",
    views: "15.3万",
    likes: 4106,
    heat: 91,
    duration: "4分钟",
    tags: ["纪念日", "重复备注", "当场对峙"],
  },
  {
    id: "case-04",
    title: "婚礼前一周，伴郎在彩排现场问了他一句不该问的话",
    category: "death",
    categoryName: "社死瞬间",
    summary:
      "所有亲友都在台下。伴郎只是开了个无心的玩笑，全场安静得能听见音响电流声，他的脸在三秒钟内换了四种颜色。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20spotlight%20on%20a%20worn%20theater%20stage%20floor%20with%20a%20single%20red%20chair%2C%20abstract%20editorial%20scene%2C%20dramatic%20overhead%20lighting%2C%20deep%20shadows%2C%20film%20grain%2C%20cinematic%20and%20theatrical%20mood%2C%20no%20people&width=800&height=600&seq=expose-case-04&orientation=landscape",
    date: "2026-09-05",
    views: "31.7万",
    likes: 11248,
    heat: 99,
    duration: "6分钟",
    tags: ["婚礼彩排", "伴郎背刺", "当众社死"],
  },
  {
    id: "case-05",
    title: "翻车合集｜他把「出差」做成了行程表，却被行李箱出卖",
    category: "collection",
    categoryName: "翻车合集",
    summary:
      "四段情节串成一条完整时间线：行程表、酒店发票、打车记录，以及行李箱夹层里那张不该出现的照片。",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20aged%20folders%20tied%20with%20red%20string%20on%20a%20warm%20concrete%20surface%2C%20abstract%20editorial%20still%20life%2C%20dramatic%20low%20key%20lighting%2C%20crimson%20thread%20accent%2C%20film%20grain%2C%20archive%20mood%2C%20no%20people&width=800&height=600&seq=expose-case-05&orientation=landscape",
    date: "2026-09-04",
    views: "42.9万",
    likes: 15630,
    heat: 100,
    duration: "12分钟",
    tags: ["行程表", "行李箱", "时间线复盘"],
  },
  {
    id: "case-06",
    title: "开门那一下，他把手里的花藏到了身后",
    category: "caught",
    categoryName: "被抓现行",
    summary:
      "她提前一小时回家，想给个惊喜。门开着，客厅里摆着两份餐具，还有一双不属于这个家的拖鞋。",
    cover:
      "https://readdy.ai/api/search-image?query=Half%20open%20door%20with%20warm%20light%20spilling%20through%20into%20a%20dark%20hallway%2C%20abstract%20cinematic%20composition%2C%20strong%20contrast%2C%20crimson%20glow%2C%20film%20grain%2C%20suspenseful%20editorial%20photography%2C%20no%20people&width=800&height=600&seq=expose-case-06&orientation=landscape",
    date: "2026-09-03",
    views: "20.4万",
    likes: 6854,
    heat: 93,
    duration: "5分钟",
    tags: ["提前回家", "第三双拖鞋", "当场撞见"],
  },
  {
    id: "case-07",
    title: "同城咖啡厅偶遇：她说自己在外地探亲",
    category: "exposed",
    categoryName: "被拆穿瞬间",
    summary:
      "隔着两张桌子，她的定位、朋友圈和手机里的聊天记录，在同一分钟里对不上任何一句解释。",
    cover:
      "https://readdy.ai/api/search-image?query=Scattered%20coffee%20cups%20and%20a%20torn%20receipt%20on%20a%20rainy%20cafe%20table%20seen%20through%20glass%2C%20abstract%20editorial%20still%20life%2C%20desaturated%20warm%20tones%20with%20crimson%20accents%2C%20film%20grain%2C%20cinematic%20mood%2C%20no%20people&width=800&height=600&seq=expose-case-07&orientation=landscape",
    date: "2026-09-02",
    views: "11.8万",
    likes: 3390,
    heat: 87,
    duration: "3分钟",
    tags: ["偶遇", "定位不符", "解释不通"],
  },
  {
    id: "case-08",
    title: "打脸现场｜他说再也不会联系，第二天评论区就出现了同款情话",
    category: "slap",
    categoryName: "打脸现场",
    summary:
      "保证书写得工工整整，第二天他就在别人的动态下面，用一模一样的句子复制粘贴了一遍。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20single%20red%20paper%20plane%20crashing%20into%20stacked%20documents%2C%20abstract%20editorial%20concept%20still%20life%2C%20warm%20paper%20background%2C%20dramatic%20lighting%2C%20film%20grain%2C%20high%20contrast%2C%20no%20people&width=800&height=600&seq=expose-case-08&orientation=landscape",
    date: "2026-09-01",
    views: "16.9万",
    likes: 5240,
    heat: 90,
    duration: "4分钟",
    tags: ["保证书", "复制粘贴", "公开打脸"],
  },
  {
    id: "case-09",
    title: "翻车合集｜三条时间线，拼出同一个「周末加班」",
    category: "collection",
    categoryName: "翻车合集",
    summary:
      "三个不同城市的姑娘，在同一个话题下留言，比对时发现她们收到的语音、礼物与借口几乎一致。",
    cover:
      "https://readdy.ai/api/search-image?query=Rows%20of%20manila%20folders%20on%20metal%20shelves%20under%20warm%20industrial%20light%2C%20abstract%20archive%20interior%2C%20crimson%20labels%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20editorial%20documentary%20photography%2C%20no%20people&width=800&height=600&seq=expose-case-09&orientation=landscape",
    date: "2026-08-30",
    views: "38.2万",
    likes: 13975,
    heat: 95,
    duration: "9分钟",
    tags: ["跨城比对", "统一话术", "组团避雷"],
  },
];

export const hotRanking = [
  { id: "rank-01", caseId: "case-04", title: "婚礼彩排上的那句玩笑，让全场安静了十秒", heat: 99, views: "31.7万" },
  { id: "rank-02", caseId: "case-01", title: "他把「加班」说了三个月，直到定位对不上", heat: 96, views: "18.6万" },
  { id: "rank-03", caseId: "case-02", title: "群发晚安误入家族群，三分钟撤回已来不及", heat: 95, views: "24.1万" },
  { id: "rank-04", caseId: "case-05", title: "行李箱夹层里的那张照片，比任何解释都直接", heat: 92, views: "42.9万" },
  { id: "rank-05", caseId: "case-07", title: "同城咖啡厅偶遇，她的行程表当场作废", heat: 88, views: "11.8万" },
];

export const topics = [
  {
    id: "topic-01",
    title: "特刊｜被拆穿的那三秒钟",
    desc: "把三十七个「当场愣住」的瞬间按反应速度排序，看看哪一秒最致命。",
    count: 37,
    label: "本周特刊",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20torn%20newspaper%20front%20page%20on%20a%20warm%20desk%20with%20crimson%20ink%20stamps%2C%20abstract%20editorial%20flat%20lay%2C%20high%20contrast%20lighting%2C%20film%20grain%2C%20vintage%20press%20mood%2C%20no%20people&width=800&height=600&seq=expose-topic-01&orientation=landscape",
  },
  {
    id: "topic-02",
    title: "专题｜异地恋翻车全档案",
    desc: "车票、定位、通话记录与「信号不好」之间的九种对不上的地方。",
    count: 24,
    label: "专题合集",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20map%20and%20paper%20plane%20on%20warm%20kraft%20paper%20background%20with%20red%20string%20route%20lines%2C%20abstract%20editorial%20flat%20lay%2C%20dramatic%20lighting%2C%20film%20grain%2C%20no%20people&width=800&height=600&seq=expose-topic-02&orientation=landscape",
  },
  {
    id: "topic-03",
    title: "专题｜统一话术识别手册",
    desc: "当不同的人收到几乎一样的台词，套路就开始露出破绽。",
    count: 19,
    label: "避雷优选",
    cover:
      "https://readdy.ai/api/search-image?query=Layered%20torn%20posters%20on%20a%20warm%20concrete%20wall%20with%20faint%20red%20brush%20strokes%2C%20abstract%20editorial%20photography%2C%20dramatic%20side%20light%2C%20film%20grain%2C%20urban%20texture%2C%20no%20people&width=800&height=600&seq=expose-topic-03&orientation=landscape",
  },
];

export const guides = [
  {
    id: "guide-01",
    title: "自查清单：一段关系进入高风险状态的九个信号",
    excerpt:
      "承诺长期无法兑现、行程永远模糊、情绪一被追问就反弹——把模糊的不安拆成可核对的条目，比反复自我怀疑有用得多。",
    readTime: "8分钟阅读",
    date: "2026-09-07",
    tag: "情感避雷",
    helpful: 1284,
    cover:
      "https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20lists%20and%20a%20red%20pen%20on%20warm%20linen%20fabric%2C%20abstract%20editorial%20flat%20lay%2C%20soft%20directional%20light%2C%20film%20grain%2C%20calm%20analytical%20mood%2C%20no%20people&width=800&height=600&seq=expose-guide-01&orientation=landscape",
  },
  {
    id: "guide-02",
    title: "保存证据的正确姿势：既保护自己，也避免踩线",
    excerpt:
      "聊天记录怎么导出、哪些信息必须打码、哪些内容不适合公开——先守住合法边界，再谈曝光这件事。",
    readTime: "6分钟阅读",
    date: "2026-09-03",
    tag: "实用工具",
    helpful: 967,
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20stack%20of%20documents%20and%20a%20folder%20with%20a%20red%20tab%20on%20a%20warm%20desk%2C%20abstract%20editorial%20still%20life%2C%20soft%20natural%20window%20light%2C%20film%20grain%2C%20orderly%20documentary%20mood%2C%20no%20people&width=800&height=600&seq=expose-guide-02&orientation=landscape",
  },
  {
    id: "guide-03",
    title: "体面退出的三个步骤：情绪、边界与时间表",
    excerpt:
      "想清楚、说明白、走干净。把离开拆成可以执行的小动作，比在深夜反复拉扯更容易真的走出去。",
    readTime: "7分钟阅读",
    date: "2026-08-29",
    tag: "情绪复原",
    helpful: 1533,
    cover:
      "https://readdy.ai/api/search-image?query=A%20packed%20suitcase%20by%20a%20window%20with%20warm%20morning%20light%20and%20folded%20papers%2C%20abstract%20editorial%20scene%2C%20crimson%20scarf%20accent%2C%20film%20grain%2C%20hopeful%20quiet%20mood%2C%20no%20people&width=800&height=600&seq=expose-guide-03&orientation=landscape",
  },
];